import { addDays } from 'date-fns';

import type { MyProfile } from '@skippay/core/@types/myProfile';

import { isBnplLimitAvailable } from 'utils/bnplLimitUtils';

import {
	BNPL_LIMITS_OFFER_PRODUCTS,
	BnplLimitsOfferMemory,
	BnplLimitsOfferProducts,
} from './types';

const BNPL_LIMITS_OFFER_FREQUENCY_DAYS = 14;

const wasSentRecently = (memory: BnplLimitsOfferMemory, now: Date): boolean => {
	if (!memory.lastSentAt) return false;
	const lastSentAt = new Date(memory.lastSentAt);
	if (Number.isNaN(lastSentAt.getTime())) return false;
	return addDays(lastSentAt, BNPL_LIMITS_OFFER_FREQUENCY_DAYS) > now;
};

export function selectBnplLimitsOffer(
	profile: MyProfile,
	memory: BnplLimitsOfferMemory,
	now: Date
): BnplLimitsOfferProducts | null {
	if (wasSentRecently(memory, now)) return null;

	const deferredPayment = isBnplLimitAvailable(profile, 'deferredPayment');
	const payInThree = isBnplLimitAvailable(profile, 'payInThree');

	if (deferredPayment && payInThree) return BNPL_LIMITS_OFFER_PRODUCTS.BOTH;
	if (deferredPayment) return BNPL_LIMITS_OFFER_PRODUCTS.DEFERRED_PAYMENT;
	if (payInThree) return BNPL_LIMITS_OFFER_PRODUCTS.PAY_IN_THREE;
	return null;
}
